import {
  ACTION_GET_CRC_POINTS,
  ACTION_GET_CRC_POINTS_SUCCESS,
  ACTION_GET_CRC_POINTS_FAILURE,
  ACTION_POST_CRC_POINTS,
  ACTION_POST_CRC_POINTS_SUCCESS,
  ACTION_POST_CRC_POINTS_FAILURE,
} from '../configs/ActionTypes';

export interface CRCReduxState {
  crcPoints: number;
  isLoading: boolean;
  success: boolean;
}

const initialState = {
  crcPoints: 0,
  isLoading: false,
  success: false,
};

export default function (state: CRCReduxState = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_CRC_POINTS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case ACTION_GET_CRC_POINTS_SUCCESS: {
      return {
        ...state,
        crcPoints: action.payload.payload.response,
        isLoading: false,
        success: true,
      };
    }
    case ACTION_GET_CRC_POINTS_FAILURE: {
      return {
        ...state,
        crcPoints: 0,
        isLoading: false,
        success: true,
      };
    }

    case ACTION_POST_CRC_POINTS: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case ACTION_POST_CRC_POINTS_SUCCESS: {
      return {
        ...state,
        crcPoints: action.payload.payload.response,
        isLoading: false,
        success: true,
      };
    }
    case ACTION_POST_CRC_POINTS_FAILURE: {
      return {
        ...state,
        crcPoints: 0,
        isLoading: false,
        success: true,
      };
    }

    default: {
      return state;
    }
  }
}
